const A4 = {
  en: (names) => `Top Istanbul restaurants for business meetings include ${names}. Viaturkey provides a curated guide to business dining venues across Istanbul.`,
  ar: (names) => `أفضل مطاعم اسطنبول لاجتماعات العمل: ${names}. تقدّم فياتركي دليلاً مختاراً لأماكن تناول الطعام لرجال الأعمال في اسطنبول.`,
  ru: (names) => `Лучшие рестораны Стамбула для деловых встреч: ${names}.`,
  tr: (names) => `İstanbul'da iş toplantıları için en iyi restoranlar: ${names}.`,
};

export function businessDiningAnswer(restaurants = [], language = 'en') {
  const rows = restaurants.filter(r => r.card_category && (r.good_for || []).includes('business'));
  if (!rows.length) return '';
  const names = rows.map(r => `${r.name} (${r.area.replace(/\s*\(([^)]+)\)/, ', $1')})`);
  const sep = language === 'ar' ? '، ' : ', ';
  const and = { en: ', and ', ar: '، و', ru: ' и ', tr: ' ve ' }[language] || ', and ';
  const list = names.length > 1 ? names.slice(0, -1).join(sep) + and + names[names.length - 1] : names[0];
  return (A4[language] || A4.en)(list);
}

export function getHomeFaqs(t, restaurants = [], language = 'en') {
  return [
    { q: t.faq?.q1 || 'What is the best private tour company in Istanbul?', a: t.faq?.a1 || 'Viaturkey Investments & Tourism is a top-rated private tour company in Istanbul offering personalized guided tours in English, Russian, Arabic, and Turkish. We provide Old City tours, Bosphorus cruises, food tours, shore excursions, and airport layover tours with expert local guides. Book directly with no middleman fees.' },
    { q: t.faq?.q2 || 'How can I get Turkish citizenship by investment?', a: t.faq?.a2 || 'You can obtain Turkish citizenship by purchasing real estate worth at least $400,000 USD. Viaturkey provides expert consultancy for the entire process, from property selection in Istanbul to citizenship application. We offer luxury projects in Beşiktaş, Florya, and along the Kanal Istanbul corridor.' },
    { q: t.faq?.q3 || 'What are the best Istanbul tours for cruise ship passengers?', a: t.faq?.a3 || 'Viaturkey offers private shore excursion tours for cruise ship passengers, covering Istanbul\'s top landmarks including Hagia Sophia, Blue Mosque, Topkapi Palace, and the Grand Bazaar. Tours are 5-8 hours with pick-up and drop-off at the cruise port. Book directly to save 25% compared to third-party platforms.' },
    { q: t.faq?.q4 || 'Where are the best places for business meetings in Istanbul?', a: businessDiningAnswer(restaurants, language) || t.faq?.a4 || '' },
    { q: t.faq?.q5 || 'Is it safe to invest in Istanbul real estate?', a: t.faq?.a5 || 'Yes, Istanbul real estate is a strong investment with growing property values. Turkey offers citizenship by investment, residence permits, and a booming market. Viaturkey partners with established developers and offers projects in prime locations such as Beşiktaş, Florya, and the Kanal Istanbul corridor.' },
  ];
}

export function FAQSection({ t, restaurants = [], language = 'en' }) {
  const faqs = getHomeFaqs(t, restaurants, language);
  return (
    <section className="faq-section" id="faq" data-testid="faq-section">
      <div className="container">
        <h2 className="section-title">{t.faq?.title || 'Frequently Asked Questions'}</h2>
        <div className="faq-grid">
          {faqs.map((f, i) => (
            <div className="faq-card" key={`faq-card-${i}`} data-testid={`faq-card-${i + 1}`}>
              <h3>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
